
import React, { useEffect, useState } from 'react';
import { supabase } from '../services/supabaseClient';
import { SiteConfig } from '../types';

interface LandingProps {
  onJoin: () => void;
  config: SiteConfig | null;
}

export const Landing: React.FC<LandingProps> = ({ onJoin, config }) => {
  const [data, setData] = useState<any>(null);
  const [modal, setModal] = useState<'rules' | 'privacy' | null>(null);
  const icons = ['✨', '🤖', '🤝', '☕️'];

  useEffect(() => {
    supabase.from('landing_content').select('*').eq('id', 'main').single().then(({ data }) => {
      if (data) setData(data.data);
    });
  }, []);

  if (!data) return <div className="h-screen flex items-center justify-center bg-black text-white font-black">V</div>;

  const Modal = ({ title, content, onClose }: { title: string, content: string, onClose: () => void }) => (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/90 backdrop-blur-xl" onClick={onClose}>
      <div className="bg-white rounded-[3rem] p-10 max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <h3 className="text-3xl font-black uppercase mb-6 tracking-tighter">{title}</h3>
        <div className="text-sm text-gray-600 space-y-4 leading-relaxed whitespace-pre-line font-medium">{content}</div>
        <button onClick={onClose} className="mt-8 w-full py-4 bg-black text-white font-black rounded-2xl uppercase tracking-widest">Закрыть</button>
      </div>
    </div>
  );

  return (
    <div className="bg-white flex flex-col w-full overflow-hidden">
      <section className="hero-gradient relative w-full h-screen flex items-center justify-center text-white p-6">
        <div className="text-center z-10 max-w-5xl">
          <div className="inline-block bg-white/10 backdrop-blur-md text-[10px] font-black px-6 py-2 rounded-full uppercase tracking-[0.3em] mb-10 animate-fadeIn">Professional Network</div>
          <h1 className="text-5xl sm:text-7xl md:text-8xl font-black tracking-tighter mb-10 leading-[0.9] uppercase animate-fadeIn">{data.hero_title}</h1>
          <p className="text-sm sm:text-lg md:text-xl text-white/70 mb-16 font-medium animate-fadeIn" style={{ animationDelay: '0.2s' }}>{data.hero_subtitle}</p>
          <button onClick={onJoin} className="px-16 py-6 bg-white text-black text-xs font-black rounded-2xl shadow-2xl uppercase tracking-[0.2em] hover:bg-red-600 hover:text-white transition-all transform hover:scale-105 active:scale-95 animate-fadeIn" style={{ animationDelay: '0.4s' }}>{data.hero_button}</button>
        </div>
      </section>

      <section className="bg-white py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-black uppercase tracking-tighter mb-16 text-center">Как это работает</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {data.steps.map((step: any, idx: number) => (
              <div key={idx} className="p-8 rounded-[2.5rem] bg-gray-50 border border-gray-100 flex flex-col items-center text-center group min-h-[280px] justify-center transition-all hover:border-red-500 hover:shadow-2xl">
                <div className="text-4xl mb-6 group-hover:scale-110 transition-transform">{icons[idx] || '☕️'}</div>
                <h4 className="text-lg font-black mb-3 uppercase tracking-tighter leading-tight">{step.title}</h4>
                <p className="text-gray-500 text-xs font-medium leading-relaxed px-4">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <footer className="bg-black py-20 px-6 text-white rounded-t-[4rem] relative">
         <div className="max-w-7xl mx-auto">
           <div className="flex flex-col md:flex-row justify-between items-center gap-12 mb-16">
             <div className="flex items-center gap-5">
                <div className="w-14 h-14 bg-red-600 rounded-2xl flex items-center justify-center font-black text-2xl shadow-lg">V</div>
                <div><p className="text-lg font-black uppercase tracking-tighter leading-none mb-1">Random Coffee Vietnam</p><p className="text-[9px] text-gray-500 font-bold uppercase tracking-widest">{data.footer_text}</p></div>
             </div>
             <div className="flex gap-8">
                <a href={data.tg_group} target="_blank" className="text-[10px] font-black uppercase tracking-widest text-gray-400 hover:text-white transition-colors">Telegram</a>
                <button onClick={() => setModal('rules')} className="text-[10px] font-black uppercase tracking-widest text-gray-400 hover:text-white transition-colors">Правила</button>
                <button onClick={() => setModal('privacy')} className="text-[10px] font-black uppercase tracking-widest text-gray-400 hover:text-white transition-colors">Приватность</button>
             </div>
           </div>
           <div className="text-center border-t border-white/5 pt-12">
              <p className="text-[9px] font-black uppercase tracking-[0.3em] text-gray-600">VIETNAM NETWORKING ENGINE • 2026</p>
           </div>
         </div>
      </footer>

      {modal === 'rules' && <Modal title="Правила" onClose={() => setModal(null)} content={config?.rules_text || 'Текст правил отсутствует.'} />}
      {modal === 'privacy' && <Modal title="Приватность" onClose={() => setModal(null)} content={config?.privacy_text || 'Текст политики отсутствует.'} />}
    </div>
  );
};
